/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrgUserSelfUpdate
 */
export interface OrgUserSelfUpdate {
    /**
     * 
     * @type {string}
     * @memberof OrgUserSelfUpdate
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserSelfUpdate
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserSelfUpdate
     */
    org_user_azure_id: string;
}

/**
 * Check if a given object implements the OrgUserSelfUpdate interface.
 */
export function instanceOfOrgUserSelfUpdate(value: object): value is OrgUserSelfUpdate {
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('org_user_azure_id' in value) || value['org_user_azure_id'] === undefined) return false;
    return true;
}

export function OrgUserSelfUpdateFromJSON(json: any): OrgUserSelfUpdate {
    return OrgUserSelfUpdateFromJSONTyped(json, false);
}

export function OrgUserSelfUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgUserSelfUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'org_user_azure_id': json['org_user_azure_id'],
    };
}

export function OrgUserSelfUpdateToJSON(json: any): OrgUserSelfUpdate {
    return OrgUserSelfUpdateToJSONTyped(json, false);
}

export function OrgUserSelfUpdateToJSONTyped(value?: OrgUserSelfUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'org_user_azure_id': value['org_user_azure_id'],
    };
}

